import { render, staticRenderFns } from "./EPFSetupNew.vue?vue&type=template&id=0d1e28ea"
import script from "./EPFSetupNew.vue?vue&type=script&lang=js"
export * from "./EPFSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports